import React, { JSX } from "react";
import { Navigate } from "react-router-dom";
import { useUser } from "../contexts/UserProvider";

type TPublicRouteProps = {
  outlet: JSX.Element;
};

export default function PublicRoute(props: TPublicRouteProps) {
  const { outlet } = props;
  const { user } = useUser();

  if (user === undefined) {
    return null;
  }

  if (user) {
    return <Navigate to="/" />;
  }

  return outlet;
}
